export default "__VITE_ASSET__DSuaHKxh__"